<template>
    <div>
        <div v-if="hasSuccesses && showSuccess" @click.prevent="hide('success')" class="alert alert-big alert-good active">
            <ul>
                <li><span v-html="success"></span><span class="fa fa-times alert-exit"></span></li>
            </ul>
        </div>

        <div v-if="hasErrors && showError" @click.prevent="hide('error')" class="alert alert-big alert-bad active">
            <ul>
                <li><span v-html="error"></span><span class="fa fa-times alert-exit"></span></li>
            </ul>
        </div>

        <div v-if="hasMessages && showMessage" @click.prevent="hide('message')" class="alert alert-big alert-neutral active">
            <ul>
                <li><span v-html="message"></span><span class="fa fa-times alert-exit"></span></li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {

    props: [ 'success', 'error', 'message' ],

    data() {
        return {
            showSuccess: true,
            showError: true,
            showMessage: true,
        }
    },

    computed: {

        hasSuccesses() {
            return this.success && this.success.length > 0;
        },

        hasErrors() {
            return this.error && this.error.length > 0;
        },

        hasMessages() {
            return this.message && this.message.length > 0;
        },
    },

    methods: {
        hide(type) {
            switch (type) {
                case 'error':
                    this.showError = false;
                    break;
                case 'message':
                    this.showMessage = false;
                    break;
                case 'success':
                    this.showSuccess = false;
                    break;
            }

            this.$store.dispatch('clearNotice', type);
        }
    }

};


</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/Messages.vue